import { TRANSPORT_OPTION_TYPES } from '@common/utils'
import {
  MolsonGrid,
  MolsonRadioButton,
  MolsonRadioGroup
} from '@components/reusable'

type TransportRadioGroupProps = {
  selectedTransportType: string
  isWithinMachine?: boolean
  onChange: (value: string) => void
  translations: Record<string, string>
}

export const TransportRadioGroup = ({
  selectedTransportType,
  isWithinMachine,
  onChange,
  translations
}: TransportRadioGroupProps) => (
  <MolsonRadioGroup
    onChange={e => onChange(e.target.value)}
    sx={{ width: '100%' }}
    row={true}
    value={selectedTransportType}
  >
    <MolsonGrid container={true} spacing={2}>
      {isWithinMachine && (
        <MolsonGrid item={true} xs={4}>
          <MolsonRadioButton
            checked={selectedTransportType === TRANSPORT_OPTION_TYPES.FITTED}
            formControlLabelProps={{ label: translations.fitted }}
            radioBtnProps={{ value: TRANSPORT_OPTION_TYPES.FITTED }}
          />
        </MolsonGrid>
      )}
      <MolsonGrid item={true} xs={isWithinMachine ? 4 : 6}>
        <MolsonRadioButton
          checked={selectedTransportType === TRANSPORT_OPTION_TYPES.DELIVERY}
          formControlLabelProps={{ label: translations.delivery }}
          radioBtnProps={{ value: TRANSPORT_OPTION_TYPES.DELIVERY }}
        />
      </MolsonGrid>
      <MolsonGrid item={true} xs={isWithinMachine ? 4 : 6}>
        <MolsonRadioButton
          checked={selectedTransportType === TRANSPORT_OPTION_TYPES.COLLECTION}
          formControlLabelProps={{ label: translations.collection }}
          radioBtnProps={{ value: TRANSPORT_OPTION_TYPES.COLLECTION }}
        />
      </MolsonGrid>
    </MolsonGrid>
  </MolsonRadioGroup>
)
